import { Link } from "react-router-dom";
import { GitBranch, Server, Globe } from "lucide-react";
import { cn } from "@/lib/utils";
import { StatusBadge } from "./StatusBadge";
import { ProjectAvatar } from "./Avatars";

// Card de projeto.
export const ProjectCard = ({ project }) => (
  <Link
    to={`/projetos/${project.id}`}
    data-testid={`project-card-${project.id}`}
    className="group block rounded-xl border border-line bg-surface p-4 transition-all duration-300 hover:border-line/60 hover:bg-surface-hover hover:-translate-y-0.5"
  >
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-center gap-3">
        <ProjectAvatar name={project.name} />
        <div>
          <p className="font-heading text-base font-semibold text-foreground">{project.name}</p>
          <p className="text-xs text-muted-foreground">{project.client}</p>
        </div>
      </div>
      <StatusBadge status={project.status} size="sm" />
    </div>
    <p className="mt-3 text-xs text-muted-foreground">{project.stack}</p>
    <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-[11px] text-muted-foreground">
      <span className="inline-flex items-center gap-1"><Server className="h-3 w-3" />{project.server}</span>
      <span className="inline-flex items-center gap-1"><GitBranch className="h-3 w-3" />{project.branch}</span>
      <span className="inline-flex items-center gap-1 truncate"><Globe className="h-3 w-3 shrink-0" />{project.domains[0]}</span>
    </div>
  </Link>
);
